import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import Swiper from 'swiper';
import Odometer from './odometer';
import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';
import { Pass, FullScreenQuad } from 'three/addons/postprocessing/Pass.js';
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';
import { FXAAShader } from 'three/addons/shaders/FXAAShader.js';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import Lottie from '@lottielab/lottie-player/web';
import { Navigation, Scrollbar, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import { parseRem, isInViewport, animRevealTitle, animRevealLabel, formatMoney, activeItem, xGetter, yGetter, xSetter, FadeSplitText, ySetter, MasterTimeline, ScaleInset, ScaleLine, FadeIn, RevealText, RevealTextReset, lerp, SlideText, getLenis, TextSplit, MaskText, Line, initFirst, Fade, MaskBox, getScreenType, ScaleBox } from '../utils';
globalThis.THREE = THREE;

globalThis.OrbitControls = OrbitControls;
globalThis.GLTFLoader = GLTFLoader;
globalThis.DRACOLoader = DRACOLoader;
globalThis.RGBELoader = RGBELoader;

globalThis.FXAAShader = FXAAShader;
globalThis.EffectComposer = EffectComposer;
globalThis.ShaderPass = ShaderPass;
globalThis.RenderPass = RenderPass;
globalThis.Pass = Pass;
globalThis.FullScreenQuad = FullScreenQuad;

globalThis.Lottie = Lottie;
globalThis.gsap = gsap;
globalThis.ScrollTrigger = ScrollTrigger;
globalThis.SplitType = SplitType;
globalThis.Swiper = Swiper;
globalThis.Odometer = Odometer;

globalThis.Navigation = Navigation;
globalThis.Scrollbar = Scrollbar;
globalThis.Pagination = Pagination;
globalThis.EffectFade = EffectFade;
globalThis.Autoplay = Autoplay;
globalThis.parseRem = parseRem;
globalThis.animRevealTitle = animRevealTitle;
globalThis.animRevealLabel = animRevealLabel;
globalThis.activeItem = activeItem;
globalThis.xGetter = xGetter;
globalThis.yGetter = yGetter;
globalThis.xSetter = xSetter;
globalThis.ySetter = ySetter;
globalThis.lerp = lerp;
globalThis.SlideText = SlideText;
globalThis.getLenis = getLenis;
globalThis.TextSplit = TextSplit;
globalThis.isInViewport = isInViewport;
globalThis.MaskText = MaskText;
globalThis.initFirst = initFirst;
globalThis.Line = Line;
globalThis.Fade = Fade;
globalThis.MaskBox = MaskBox;
globalThis.getScreenType = getScreenType;
globalThis.ScaleBox = ScaleBox;
globalThis.MasterTimeline = MasterTimeline;

globalThis.RevealText = RevealText;
globalThis.RevealTextReset = RevealTextReset;
globalThis.FadeSplitText = FadeSplitText;

globalThis.ScaleLine = ScaleLine;
globalThis.FadeIn = FadeIn;
globalThis.ScaleInset = ScaleInset;
globalThis.formatMoney = formatMoney;

gsap.registerPlugin(ScrollTrigger);